import React from 'react';

import Form from "../Form";



const InvitationNewView = ({onSuccess = () => null, onSubmitting = () => null, onError = () => null}) => 
  <Form invitation={{}} onSubmitting={onSubmitting} onError={onError} onSuccess={onSuccess} />

export default InvitationNewView;